var zh_CN = {};
module['exports'] = zh_CN;
zh_CN.title = "Chinese";
zh_CN.address = require("./address");
zh_CN.name = require("./name");
zh_CN.phone_number = require("./phone_number");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_CN/index.js
// module id = 1387
// module chunks = 0